import { execute_generator } from './index'

const alert_root = '/alerts'
const alert_url = process.env.VUE_APP_API_ALERT_URL

/* This requests are for Alert Profiles */
export const getAlert = id => execute_generator(
    'GET', 
    { service: alert_url, resource:`${alert_root}/profile/${id}`}
)

export const getAlertsByAccount = accountId => execute_generator(
    'POST',
    { service: alert_url, resource:`${alert_root}/profile/byacctid`},
    { accountId: accountId }
)

export const createAlert = body => execute_generator(
    'POST', 
    { service: alert_url, resource:`${alert_root}/profile`},
    body
)

export const updateAlert = data => execute_generator(
    'PUT', 
    { service: alert_url, resource:`${alert_root}/profile/${data.id}` },
    data
)

export const create_default_alerts = accountId => execute_generator(
    'POST', { service: alert_url, resource: `${alert_root}/default/${accountId}`}, {}
).next()


/* Here, we begin with the alert history request. */
export const get_alert_history = body => execute_generator(
    'POST', { service: alert_url, resource:`${alert_root}/search/violations`}, body 
).next()
    
export const getAlertTypes = () => execute_generator(
    'GET', { service: alert_url, resource: `${alert_root}/types`}
).next()

export const getAlertTimezones = () => execute_generator(
    'GET', { service: alert_url, resource: `${alert_root}/timezones/us`}
).next()
